
import { Product } from "@/types/product";

export const vpxTC1UCP: Product = {
  id: "vpx-tc1-ucp",
  groupId: "avoip",
  name: "VPX-TC1-UCP",
  subtitle: "1Gbps AV over IP with USB-C",
  description: "The VPX-TC1-UCP provides the most flexible 4K 1G AV over IP PoE++ power distribution for its 2 USB-C inputs and RJ-45 PSE output. Up to 90 watts can be used to charge 60 watts on the USB-C port while another USB-C or RJ-45 can power 15 watts. The optional Aurora small form factor USB-C 240W adaptor will allow 100 watts per USB-C port and 15 watts for the RJ-45 PSE port.\n\nAudio, video, data, and control can be sent securely to one or many units using off-the-shelf 1G RJ-45 Ethernet switch. When the VPX-TC1 transceiver is set up to be a transmitter, the 2 USB-C & 2 HDMI inputs become a source switch, and the HDMI output becomes a potential loop out.\n\nWhen set up as a receiver, a user can select the local HDMI inputs or an IP source. Seamless switching of the sources further enhances the presentation. Regardless of how the VPX-TC1 is set up, the audio can be de-embedded at any location, and/or be sent to or received from a Dante® enabled device.\n\nThe USB is also flexible, working as a KVM and/or a high-speed data transfer (270Mbps) for memory sticks & cameras. Each VPX-TC1 USB feature can also be set as a host or a device. To keep the system friendly, an OSD and integrated web server are available for easy navigation and setup of features.\n\nDigital signage, education, corporate, and residential are just a few markets which benefit from the flexibility and low cost of the VPX-TC1-UCP.",
  features: [
    "1G LAN PoE PD, 1G LAN PoE 15 Watt PSE and SFP for Fiber",
    "2 USB-C Inputs with up to 100 Watt Power",
    "2 HDMI Inputs, 1 HDMI Output",
    "Configure as Encoder or Decoder",
    "4K60 4:4:4 UHD 120m over 1G CAT 5e",
    "Zero Frame Latency (1.78ms)",
    "HDMI 2.0b, HDCP 2.2",
    "HDR10, HDR10+, Dolby Vision",
    "LPCM up to 12-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio & ATMOS",
    "12 bits color depth processing, 16bits OSD",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Low Power Fanless Design",
    "Scaling & Seamless Switching",
    "MJPEG Preview up to 720p30",
    "Video Wall with Image Rotation",
    "Line In/Out Stereo",
    "RS-232 Serial Port and IR (In/Out)",
    "Channel Mapping with On-Screen Preview",
    "Integrated Web Server for Configuration",
    "USB 2.0 Ports for Cameras (Front), HID & Mass Storage, etc. (Rear)",
    "AES67 Included",
    "Dante® 2 Ch Audio License Option",
    "Rack and Under Table Mounting (Included)"
  ],
  images: [
    "/lovable-uploads/vpx-tc1-ucp-front.png",
    "/lovable-uploads/vpx-tc1-ucp-front-angle.png",
    "/lovable-uploads/vpx-tc1-ucp-front-angle-2.png",
    "/lovable-uploads/vpx-tc1-ucp-rear.png"
  ],
  slug: "vpx-tc1-ucp",
  networkSpeed: "1gb"
};
